export default __webpack_public_path__ + "static/media/certificate_altrom_fr.73902c73.svg";